function updateCollectionPrices (variantIdsArray) {
  var variantIds = variantIdsArray.join(",");

  var lastVariantId = variantIdsArray[variantIdsArray.length-1];
  

  var getPriceUrl = cartBaseUrl + getProductPricesEndPoint+ "?variantIds="+lastVariantId;
//   var getPriceUrl = cartBaseUrl + getCollectionProductPricesEndPoint + "?variantIds=";
  
 var getVariantPriceDetailResponseId = "";

  $.ajax({
        async: true,
        type: 'GET',
        timeout: ajaxCallTimeout,
        dataType: 'json',
        contentType: 'application/json',
        error: function (request, textStatus, errorThrown) {
          getVariantPriceDetailResponseId = (request.getResponseHeader('X-Request-ID'));
          
          Sentry.configureScope(function(scope) {
            scope.setLevel('error');
            scope.setTag("Request-Id", getVariantPriceDetailResponseId);
          });

          Sentry.captureMessage('Error in ajax request, Request-Id '+getVariantPriceDetailResponseId+" Function name: updateCollectionPrices");
          
        },
        url: getPriceUrl,
        beforeSend: function (xhr) {},
        complete: function () {},
        statusCode: {
            200: function (data) {
              drawPrices(data,variantIds,getVariantPriceDetailResponseId)
            },
            302: function () {
                swal({
                    title: 'Sorry',
                    text: "Session expired. Please login again.",
                    type: 'error',
                    confirmButtonText: 'OK',
                    allowOutsideClick: false
                });
                $('.swal2-confirm').click(function () {
                    location.reload(true);
                });
            },
            403: function () {
                swal({
                    title: 'Error!',
                    text: 'You do not have enough privilege to perform this request.' +
                    'Please contact seller support.',
                    type: 'error',
                    confirmButtonText: 'OK',
                    allowOutsideClick: false
                });
            },
            400: function () {
                swal({
                    title: 'Invalid Input!',
                    text: 'Invalid request please check input.',
                    type: 'error',
                    confirmButtonText: 'OK',
                    allowOutsideClick: false
                });
            },
            422: function () {
                swal({
                    title: '',
                    text: "Email id not exists",
                    type: 'warning',
                    confirmButtonText: 'OK',
                    allowOutsideClick: false
                });
                $('.swal2-confirm').click(function () {
                    location.reload(true);
                });
            },
            500: function () {
                swal({
                    title: 'Internal Server Error !',
                    text: 'Internal server error. We could not perform the operation this time. ' +
                    'Please try again later.',
                    type: 'error',
                    confirmButtonText: 'OK',
                    allowOutsideClick: false
                });
            }
        }
    });
};


function drawPrices(response,variantIds,responseId) {
 
  if (response !== undefined && Object.keys(response).length > 0) {
    let variantsArray = response.variants;
//     collectionPriceResult = variantsArray;
    for(var i=0;i<variantsArray.length;i++) {
      collectionPriceResult.push(variantsArray[i]);
    }
    
    if (variantsArray !== undefined && variantsArray !== null && variantsArray.length > 0) {
      for (let variantObj of variantsArray) {
        if (variantObj !== undefined && Object.keys(variantObj).length > 0) {
          let priceList = "";
          let sellingPrice = parseFloat(variantObj.variant_sale_price).toFixed(2);
          var price = 0;
          if (variantObj.is_variant_in_sale) {
            priceList = `<li style='font-weight: 500;'>Rs. ${sellingPrice}</li>`;
            price = parseFloat(variantObj.variant_sale_price).toFixed(2);
          } else {
            priceList = `<li style='font-weight: 500;'>Rs. ${variantObj.price }</li>`;
            price = variantObj.price;
          }
          
          let mrpPriceValue = parseFloat(variantObj.compare_at_price).toFixed(2);
          let mrpPrice = `<li style='color:#9c9c9c; text-decoration:line-through;'>Rs. ${mrpPriceValue}</li>`;
          
//           priceList = "<ul class='list-inline' style='margin-bottom: 10px !important'>"+ mrpPrice + priceList +"</ul>";
          
          
          if (parseInt(mrpPriceValue) === parseInt(price)) {
            priceList = "<ul class='list-inline' style='margin-bottom: 10px !important'>"+ priceList +"</ul>";
          } else {
            priceList = "<ul class='list-inline' style='margin-bottom: 10px !important'>"+ mrpPrice + priceList +"</ul>";
          }
          
          $('#price_'+variantObj.id).html(priceList);
          var collectionSavePercent = (parseInt((1-(parseInt(price)/parseInt(mrpPriceValue)))*100))+"% OFF";
          $('#collectionPercent_'+variantObj.id).html(collectionSavePercent);
          
          if ((variantIds.indexOf(","))>=0) {
            let variantIdArray = variantIds.split(",");
            if (variantIdArray.length > 0) {
              for (let varId of variantIdArray) {
                if (variantIdArray.length > 11) {
                  setTimeout(function(){
                     $('#addToCart_'+varId).prop('disabled',false);
                  },200)
                 
                }
                
                $('#addToCart_'+varId).prop('disabled',false);
              }
            }
          }
          
          $('#addToCart_'+variantObj.id).prop('disabled',false);
        } else {
          
          var ids = variantIds.split(",");
          var lastVariantId = ids[ids.length-1];

          Sentry.configureScope(function(scope) {
            scope.setLevel('fatal');
          });

          Sentry.configureScope(function(scope) {
            scope.setTag("Request-Id", responseId);
          });

//           Sentry.captureMessage('Add to cart button is not visible for variatnId:'+lastVariantId+"RequestId"+responseId);
          
        }
      }
    } else {
      
      var ids = variantIds.split(",");
      var lastVariantId = ids[ids.length-1];
      
      Sentry.configureScope(function(scope) {
        scope.setLevel('fatal');
      });

      Sentry.configureScope(function(scope) {
        scope.setTag("Request-Id", responseId);
      });

//       Sentry.captureMessage('Add to cart button is not visible for variatnId:'+lastVariantId+"RequestId"+responseId);
      
    }
  }
}